import main from './main';
import './cf7-cookies';

main();

